import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import styles from 'src/styles/common.module.scss'

const BREAKPOINT_RULES: Record<string, string[]> = {
    desktop: ['obțineți'],
    small: ['biletele', 'bonusul'],
}

export const TextHeaderRo = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    let breakAfterWords = BREAKPOINT_RULES.small

    if (isDesktop) {
        breakAfterWords = BREAKPOINT_RULES.desktop
    }

    return (
        <HighlightedText
            text="Răzuiți biletele și obțineți bonusul dumneavoastră"
            highlights={[{ word: 'bonusul' }, { word: 'dumneavoastră' }]}
            breakAfterWords={breakAfterWords}
            className={styles.text_header}
        />
    )
}
